import location from './location';
import widgetInfo from './widgetInfo';
import distance from './distance';

export default {
	location,
	widgetInfo,
	distance
};
